module.exports = __webpack_public_path__ + "img/Felbokning.b898d1cc.jpg";